import { render, staticRenderFns } from "./UsersStore.vue?vue&type=template&id=2baa1fe7&"
import script from "./UsersStore.vue?vue&type=script&lang=js&"
export * from "./UsersStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports